import { render, staticRenderFns } from "./UserShare.vue?vue&type=template&id=697c88da&"
import script from "./UserShare.vue?vue&type=script&lang=js&"
export * from "./UserShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports